module.exports = __webpack_public_path__ + "assets/8d299e3c919129b481f05996d0008480.svg";